import { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import AuthHeader from './Header/AuthHeader';
import BackgroundSwish from './BackgroundSwish';
import RebrandBanner from './Header/RebrandBanner';

const LoginSection = styled.section`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 32px 12px;
  flex: 1;

  @media (min-height: 750px) {
    justify-content: center;
    padding: 0 12px;
  }

  .ant-form-item-required {
    font-size: 16px;
  }

  .ant-form-item-extra,
  // IDE notes this as not being used but actually sets top margin of input error messages
  .ant-form-item-explain {
    margin-top: 5px;
  }

  // IDE notes this as not being used but actually helps set the password input height to have no vertical padding
  .ant-input-affix-wrapper {
    padding: 0 11px;
  }

  .ant-input {
    height: 3em;
    font-size: 16px;
  }

  .login-alert {
    margin: 0 0 20px;
  }

  .login-card {
    border: 1px solid #e3e8ef95;
    border-radius: 24px;
    margin-right: auto;
    margin-left: auto;
    box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;
    padding: 32px;
    text-align: center;
    max-width: 600px;
    background: #fff;
    width: 100%; /* Ensures card behaves nicely within the flex layout */

    @media (max-width: 576px) {
      margin-top: 20%;
    }
  }
`;

const LoginLayout: FC<{ children: ReactNode; }> = ({ children }) => {
  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <RebrandBanner />
      <div
        style={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <AuthHeader />
        <LoginSection>{children}</LoginSection>
        <BackgroundSwish />
      </div>
    </div>
  );
};

export default LoginLayout;
